import { z } from "zod";

import { ADMIN_ROLES } from "../constants/adminRoles.js";

// POST /invitations/send (single admin invitation: creates user + sends email)
export const SendInvitationRequestSchema = z.object({
    first_name: z.string().min(1),
    last_name: z.string().min(1),
    email: z.email(),
    role: z.enum(ADMIN_ROLES),
    /** Optional LinkedIn member profile URL (#617); "" / null = none. */
    linkedin_url: z.string().nullable().optional(),
});
export type SendInvitationRequest = z.infer<typeof SendInvitationRequestSchema>;

// POST /invitations/send-bulk (bulk user invitation)
export const SendBulkInvitationRequestSchema = z.object({
    user_ids: z.array(z.uuid()).min(1).max(10),
    custom_message: z.string().max(500).optional(),
});
export type SendBulkInvitationRequest = z.infer<typeof SendBulkInvitationRequestSchema>;

// Response for bulk send
export const SendBulkInvitationResponseSchema = z.object({
    success: z.boolean(),
    data: z.object({
        sent: z.array(z.uuid()),
        failed: z.array(z.uuid()),
    }),
});
export type SendBulkInvitationResponse = z.infer<typeof SendBulkInvitationResponseSchema>;
